import{utils,LitElement,html,broadcastReceiver}from '@hh/global.js'
const{serializeForm,getCart,addToCart,reRenderShopifySections}=utils
class HHProductForm extends LitElement{constructor(){super()}
connectedCallback(){super.connectedCallback()
this.form=this.querySelector('form')
this.form.setAttribute('action','javascript:void(0)')
this.quanityInput=this.querySelector('[name="quantity"]')
this.submitButton=this.querySelector('[type="submit"]')
this.receiver=broadcastReceiver('quantity',(...args)=>{this.getQuantityFromDocument(...args)
this.updateBtnQty(...args)})
this.handlerSubmit=this.onSubmitHandler.bind(this)
this.form.addEventListener('submit',this.handlerSubmit)
this.addEventListener('addToCart',this.handlerSubmit)
window.addEventListener('cart:changed',this.onCartUpdate.bind(this))
window.addEventListener('variant:change',this.onVariantChange.bind(this))}
disconnectedCallback(){super.disconnectedCallback()
this.receiver?.disconnect()
this.removeEventListener('addToCart',this.handlerSubmit)
window.removeEventListener('cart:changed',this.onCartUpdate)}
onVariantChange(e){this.form=this.querySelector('form')
this.setLineProperties(e.detail)}
getQuantityFromDocument(data){if(this.quanityInput){this.quanityInput.value=data.value||1}else if(document.querySelector('.js-pdp-quantity-input')){const quantityWrapper=document.querySelector('.js-pdp-quantity-input')
const quantityInput=quantityWrapper?.shadowRoot.querySelector('input')
this.quanityInput.value=quantityInput?.value??1}}
onCartUpdate(event){const{cart}=event.detail
const form=this.querySelector('.js-product-form')
const params=JSON.parse(serializeForm(form))
let{max}=form.dataset
const qtyInCart=cart.items.filter(item=>item.variant_id===+params.id).map(item=>item.quantity).reduce((a,b)=>a+b,0)
if(typeof max==='undefined')return;max-=qtyInCart
this.querySelector('hh-quantity-input').setAttribute('max',Math.max(max,1))
this.querySelector('[name="quantity"]').value=1
this.querySelector('hh-quantity-input')._value=1
if(max===0){this.querySelector('[type="submit"]').setAttribute('disabled',!0)
this.querySelector('.js-pdp-quantity-message').classList.remove('hidden')}else{this.querySelector('[type="submit"]').removeAttribute('disabled')
this.querySelector('.js-pdp-quantity-message').classList.add('hidden')}}
updateBtnQty(data){const buttonEl=this.querySelector('.js-single-atc')
const stickyATCButton=document.querySelector('.js-sticky-atc')
const unitPrice=buttonEl?.dataset.price;const totalPrice=unitPrice*(data.value||1)
let buttonText=buttonEl.text
const toKeep=buttonText.split(' - ')[0]
let formattedPrice=HH.formatMoney(totalPrice,window.shopSettings.money_with_currency_format,!0)
buttonText=`${toKeep} - ${formattedPrice}`
buttonEl.text=buttonText
if(stickyATCButton?.buttonContent){stickyATCButton.buttonContent=buttonText}
if(!this.querySelector('hh-quantity-input').hasAttribute('max'))return
const max=parseInt(this.querySelector('hh-quantity-input').getAttribute('max')||0)
if((data.value||1)>=max){this.querySelector('.js-pdp-quantity-message').classList.remove('hidden')}else{this.querySelector('.js-pdp-quantity-message').classList.add('hidden')}}
get isBundle(){return this.dataset.type==='bundle'}
randomFixedInteger(length){return Math.floor(Math.pow(10,length-1)+Math.random()*(Math.pow(10,length)-Math.pow(10,length-1)-1))}
setLineProperties(data){const lineProperties=data?.metafields?.lineProperties
if(!this.querySelector('.js-variant-properties'))return
if(!!lineProperties){this.querySelector('.js-variant-properties').removeAttribute('disabled')
this.querySelector('.js-variant-properties').value=JSON.stringify(lineProperties)}else{this.querySelector('.js-variant-properties').setAttribute('disabled','')
this.querySelector('.js-variant-properties').value=''}}
async onSubmitHandler(event){event.preventDefault()
event.stopImmediatePropagation();const{target}=event
let submitButton=this.submitButton
if(target!==this.form){submitButton=target}
submitButton.setAttribute('disabled',!0)
submitButton.classList.add('loading')
let cart=await getCart()
const{items}=cart
if(this.isBundle){const parent_id=Number(this.dataset.parentVariantId)||0
const items=Array.from({length:Number(this.quanityInput.value)||1}).flatMap(i=>{const itemKey=this.randomFixedInteger(14)
return Array.from(document.querySelectorAll('.js-bundle-item-id')).map(item=>{const index=item.dataset.index
const lineProperties=document.querySelector(`.js-bundle-item-properties[data-index="${index}"]`).value
return{id:Number(item.value),quantity:1,properties:Object.assign({'_is-bundle':!0,'_attached-item-key':itemKey,'_bundle-id':itemKey,'_parent-id':parent_id},!!lineProperties?JSON.parse(lineProperties):{})}})})
reRenderShopifySections(await addToCart({items}))}else{const params=JSON.parse(serializeForm(this.form))
const metafields=this.getMetafieldVariantData(params.id)
const lineItems=[]
if(metafields.bxgyGifts!==null){const gifts=JSON.parse(window.atob(metafields.bxgyGifts))
let addableGift=!1
if(metafields.bxgyGiftQty>0&&metafields.bxgyReqQty>0&&gifts.length===1){addableGift=await this.addableAutoBXGY(params,metafields,gifts[0])}
if(addableGift){const bxgy_id=typeof addableGift==='boolean'?this.randomFixedInteger(14):addableGift
params.properties={...(params.properties||{}),'_bxgy-id':bxgy_id}
lineItems.push(params)
const hasBxgy=items.some((item)=>item.properties['_is-bxgy'])
if(typeof addableGift==='boolean'&&!hasBxgy){lineItems.push({id:gifts[0].id,quantity:1,properties:{'_is-bxgy':!0,'_bxgy-id':bxgy_id}})}
reRenderShopifySections(await addToCart({items:lineItems}))}else{reRenderShopifySections(await addToCart(params))}}else{reRenderShopifySections(await addToCart(params))}}
submitButton.removeAttribute('disabled')
submitButton.classList.remove('loading')
cart=await getCart()
document.dispatchEvent(new CustomEvent('cart:changed',{bubbles:!0,detail:{cart}}))
this.dispatchEvent(new CustomEvent('productAdded',{bubbles:!0,detail:{cart}}))
window.Klarna?.OnsiteMessaging?.refresh()
this.openCart()}
async addableAutoBXGY(params,variant,gift){const cart=await getCart()
const{items}=cart
const active_qty=Number(params.quantity)||1
let bxgy_id=!1,total_count=active_qty
const parentItems=items.filter(item=>item.variant_id===variant.id)
parentItems.forEach(item=>{if(item.properties['_bxgy-id']){bxgy_id=item.properties['_bxgy-id']}
total_count+=item.quantity})
let gifts_count=0
if(bxgy_id){items.forEach(item=>{if(item.properties['_is-bxgy']&&item.properties['_bxgy-id']===bxgy_id){gifts_count+=item.quantity}})}
if(total_count>=variant.bxgyReqQty&&gifts_count===0&&variant.bxgyGiftQty===1){return!0}else{return bxgy_id}}
async onSubmitFromEvent(event){event.preventDefault()
const{target}=event
target.setAttribute('disabled',!0)
target.classList.add('loading')
reRenderShopifySections(await addToCart(JSON.parse(serializeForm(this.form))))
const cart=await getCart()
target.removeAttribute('disabled')
target.classList.remove('loading')
document.dispatchEvent(new CustomEvent('cart:changed',{bubbles:!0,detail:{cart}}))
this.openCart()
window.Klarna?.OnsiteMessaging?.refresh()}
getMetafieldVariantData(variant_id){this.metafieldVariantData=this.metafieldVariantData||JSON.parse(document.querySelector('#variantMetafields').textContent)
return this.metafieldVariantData.find(data=>data.id===Number(variant_id))}
openCart(){document.body.classList.add('mini-cart-is-visible')
setTimeout(()=>{document.querySelector('html').classList.add('overflow-hidden')
document.body.classList.add('mini-cart-is-active')
document.querySelector('.js-mega-menu-overlay').classList.add('active')})}
render(){return html`<slot></slot>`}}
customElements.define('hh-product-form',HHProductForm)